export default __webpack_public_path__ + "static/media/attendance-present.3769c9fc.svg";